import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Actions as REPORTACTIONS } from "../../store/actions/reportActions";
import { v4 as uuidv4 } from "uuid";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import ReactDOM from "react-dom";
// import axios from 'axios';
// import {NotificationContainer, NotificationManager} from 'react-notifications';
// import "react-notifications/lib/notifications.css";
import ReportHeaderTable from "./ReportHeaderTable";
import cleanDeep from "clean-deep";
import BuddySelector from "buddy/selector";

import apiURL from "../../store/actions/apiURL";

const reportGroupOptions = [
	{
		value: "Employee",
		label: "Employee",
	},
	{
		value: "Pay Period",
		label: "Pay Period",
	},
	{
		value: "Leave",
		label: "Leave",
	},
	{
		value: "Payroll",
		label: "Payroll",
	},
	{
		value: "Pension",
		label: "Pension",
	},
	{
		value: "Statutory",
		label: "Statutory",
	}
]

const ReportBuilder = ({ isAdvisor, customReports, favouritedReports, saveCustomReports, saveFavouritedReports }) => {
	const [loaded, setLoaded] = useState(false);

	let { id: reportId } = useParams();

	const reverseCleanArray = (array) => {
		return array.map((item) => (item == null ? "" : Array.isArray(item) ? reverseCleanArray(item) : item));
	};

	useEffect(() => {
		if (!loaded && reportId && reportId != "new") {
			// set loaded right away to avoid a re-trigger
			setLoaded(true);
			fetch(apiURL + "/report/template/" + reportId, {
				credentials: "include",
				method: "GET",
				headers: {
					"Accept": "application/json",
					"Content-Type": "application/json",
				},
			})
				.then((response) => response.json())
				.then((data) => {
					// obtained data
					// console.log('headerData',reverseCleanArray(data.header))
					setReportType(data.reportType);
					setTableData(reverseCleanArray(data.header));
					setColumnData(reverseCleanArray(data.columns));
					setReportName(data.name);
					setReportGroup(reportGroupOptions.find((option) => option.value === (data?.reportGroup ?? "Employee")));
					changeReportType(data.reportType);
				});
		}
	}, [reportId]);

	const headerVariables = [
		{
			id: "startDate",
			display: "Start Date",
		},
		{
			id: "endDate",
			display: "End Date",
		},
		{
			id: "generationDate",
			display: "Generation Date",
		},
		{
			id: "generationTime",
			display: "Generation Time",
		},
		{
			id: "companyName",
			display: "Company Name",
		},
	];

	const columnDefaultVariables = {
		employee: [
			{
				id: "employeeName",
				display: "Name",
			},
			{
				id: "employeeSurname",
				display: "Surname",
			},
			{
				id: "employeeFullName",
				display: "Full Name",
			},
			{
				id: "department",
				display: "Department",
			},
			// {
			//   id: 'employeeId',
			//   display: 'Employee Id',
			// },
			{
				id: "employeeReference",
				display: "Employee Reference",
			},
			{
				id: "employeePhone",
				display: "Phone",
			},
			{
				id: "employeeEmail",
				display: "Email",
			},
			{
				id: "maritialStatus",
				display: "Maritial Status",
			},
			{
				id: "gender",
				display: "Gender",
			},
			{
				id: "employeeAddressHouse",
				display: "Address House",
			},
			{
				id: "employeeAddressStreet",
				display: "Address Street",
			},
			{
				id: "employeeAddressCity",
				display: "Address City",
			},
			{
				id: "employeeAddressPostCode",
				display: "Address PostCode",
			},
			{
				id: "employeeNationality",
				display: "Nationality",
			},
			{
				id: "employeeSocialSecurity",
				display: "SocialSecurity",
			},
			{
				id: "employeeIdCard",
				display: "Id Card No",
			},
			{
				id: "employeeTaxNo",
				display: "Id Tax No",
			},
			{
				id: "employeeDob",
				display: "Date of Birth",
			},
			{
				id: "employeeMarried",
				display: "is Married",
			},
			{
                id: "employeeType",
                display: "Employment Type",
			},
			{
				id: "employeeTaxStatus",
				display: "Employee Tax Bracket",
			},
			{
				id: "fullTimeStatus",
				display: "SSC Status",
			},
			{
				id: "fullTimeEmployer",
				display: "Main Employer NI",
			},
			{
				id: "sickBenefitRate",
				display: "Sick Benefit Rate",
			},
			{
				id: "employeeTaxRate",
				display: "Employee Custom Tax Rate",
			},
			{
				id: "employeePaysMinimumTax",
				display: "Employee Pays Minimum Tax",
			},
			{
				id: "startDate",
				display: "Date of Employment",
			},
			{
				id: "originalEngagement",
				display: "Original Date Employed",
			},
			{
				id: "endDate",
				display: "Date of Termination",
			},
			{
				id: "employeeRole",
				display: "Employee Role",
			},
			{
				id: "employeeBank",
				display: "Employee Bank Name",
			},
			{
				id: "employeeBankIban",
				display: "Employee IBAN",
			}, // it's Encrypted
			{
				id: "employeeBankSwift",
				display: "Employee Swift",
			},
			{
				id: "employeeBankAccountHolder",
				display: "Employee Bank Account Holder Name",
			},
			{
				id: "companyEmail",
				display: "Employee's Company Email Address",
			},
			{
				id: "hourlyPay",
				display: "Hourly Pay",
			},
			{
				id: "weeklyPay",
				display: "Weekly Pay",
			},
			{
				id: "weeklyHours",
				display: "Weekly Hours Contracted",
			},
			{
				id: "casual",
				display: "Is Casual",
			},
			{
				id: "managerial",
				display: "Is managerial (Overtime 15% does not apply)",
			},
			{
				id: "suspendBonus",
				display: "Has Bonus Suspended",
			},
			{
				id: "employeeReference",
				display: "Employee Reference (used for timesheets)",
			},
		],
		salaryInfo: [
			{
				id: "employeeSalary",
				display: "Employee Salary",
			},
			{
				id: "employeeSalaryFrequency",
				display: "Employee Salary Frequency",
			},
			{
				id: "employeeSalaryNetOrGross",
				display: "Employee Salary Net or Gross",
			},
		],
		payInfo: [
			{
				id: "basicHours",
				display: "Basic Hours",
			},
			{
				id: "basicPay",
				display: "Basic Pay",
			},
			{
				id: "basicHoursExcludingLeave",
				display: "Basic Hours Excluding Leave",
			},
			{
				id: "basicPayExcludingLeave",
				display: "Basic Pay Excluding Leave",
			},
			{
				id: "grossPay",
				display: "Gross Pay",
			},
			{
				id: "taxablePay",
				display: "Taxable Pay",
			},
			{
				id: "netPay",
				display: "Net Pay",
			},
			{
				id: "preTax",
				display: "Pre Tax (inputs + values)",
			},
			{
				id: "preTaxInput",
				display: "Pre Tax Hours or Multiplier",
			},
			{
				id: "preTaxValue",
				display: "Pre Tax Amount",
			},
			{
				id: "postTax",
				display: "Post Tax (inputs + values)",
			},
			{
				id: "postTaxInput",
				display: "Post Tax Hours or Multiplier",
			},
			{
				id: "postTaxValue",
				display: "Post Tax Amount",
			},
			{
				id: "taxByTypeAndPayer",
				display: "Taxes grouped by tax type and payer",
			},
			{
				id: "employeeTaxesByType",
				display: "Employee Deductions by type",
			},
			{
				id: "employerTaxesByType",
				display: "Employer Contributions by type",
			},
			{
				id: "taxByType",
				display: "Taxes grouped by Tax Name",
			},
			{
				id: "taxByEmployee",
				display: "Taxes Total by Employee (deductions)",
			},
			{
				id: "taxByEmployer",
				display: "Taxes Total by Employer",
			},
			{
				id: "proRataStatutoryBonus",
				display: "Statutory Bonus",
			},
			{
				id: "proRataWeeklyAllowance",
				display: "Weekly Allowance",
			},
			{
				id: "totalPaidLeaveHours",
				display: "Total Hours of Paid Leave Taken",
			},
			{
				id: "totalPaidLeaveValue",
				display: "Total Paid Leave Value",
			},
			{
				id: "sickLeaveHours",
				display: "Sick Leave Hours",
			},
			{
				id: "vacationLeaveHours",
				display: "Vacation Leave Hours",
			},
			{
				id: "vacationLeaveValue",
				display: "Vacation Leave Value",
			},
			{
				id: "proRataVacationLeaveDue",
				display: "Pro Rata Vacation Leave Hours Due",
			},
			{
				id: "proRataVacationLeavePayDue",
				display: "Pro Rata Vacation Leave Pay Due",
			},
			{
				display: "Leave Balance in Payslip: Carryover",
				id: "leaveCarryover",
			},
			{
				display: "Leave Balance in Payslip: TOIL",
				id: "leaveToil",
			},
			{
				display: "Leave Balance in Payslip: Entitled",
				id: "leaveEntitled",
			},
			{
				display: "Leave Balance in Payslip: Entitled To Date",
				id: "leaveEntitledToDate",
			},
			{
				display: "Leave Balance in Payslip: Consumed",
				id: "leaveConsumed",
			},
			{
				display: "Leave Balance in Payslip: Paid Leave",
				id: "leavePaidLeave",
			},
			{
				display: "Leave Balance in Payslip: Remaining",
				id: "leaveRemaining",
			},
			{
				display: "Leave Balance in Payslip: Remaining To Date",
				id: "leaveRemainingToDate",
			},
			{
				display: "Payroll Totals to Date",
				id: "totalsToDate",
			},
		],
		payBreakdown: [
			{
				id: "payElement",
				display: "Pay Element",
			},
			// {
			//   id: 'payNominalCode',
			//   display: 'Nominal Code',
			// }, //to do
			{
				id: "payAmount",
				display: "Pay Amount",
			},
			{
				id: "payAmountDebit",
				display: "Pay Debit Amount",
			},
			{
				id: "payAmountCredit",
				display: "Pay Credit Amount",
			},
			{
				id: "payPreviousAmount",
				display: "Pay Previous Amount",
			},
			{
				id: "payVariance",
				display: "Pay Variance",
			},
			{
				id: "payPercentageChange",
				display: "Pay Percentage Change",
			},
		],
	};

	//TODO add all allowance/OT types to salary info
	//TODO add all allowance/OT/tax types to pay info

	const [columnVariables, setColumnVariables] = useState([
		// ...headerVariables,
		...columnDefaultVariables["employee"],
		...columnDefaultVariables["salaryInfo"],
	]);

	const changeReportType = (event) => {
		let type = event?.target?.value ?? event;

		switch (type) {
			case "Employee Data":
				setColumnVariables([
					// ...headerVariables,
					...columnDefaultVariables["employee"],
					...columnDefaultVariables["salaryInfo"],
				]);
				break;
			case "Consolidated Payroll Data":
				setColumnVariables([
					// ...headerVariables,
					...columnDefaultVariables["payBreakdown"],
				]);
				break;
			case "Payroll Data by Employee":
				setColumnVariables([
					// ...headerVariables,
					...columnDefaultVariables["employee"],
					...columnDefaultVariables["payInfo"],
				]);
				break;
			case "Payroll Breakdown":
				setColumnVariables([
					// ...headerVariables,
					// ...columnDefaultVariables['employee'],
					columnDefaultVariables["employee"][0], // Name
					columnDefaultVariables["employee"][1], // department
					...columnDefaultVariables["payBreakdown"],
				]);
				break;
		}

		setReportType(type);
	};

	// const columnVariables = columnVariables || [
	//   {
	//     id: 'startDate',
	//     display: 'Start Date',
	//   },
	//   {
	//     id: 'endDate',
	//     display: 'End Date',
	//   },
	//   {
	//     id: 'generationDate',
	//     display: 'Generation Date',
	//   },
	//   {
	//     id: 'generationTime',
	//     display: 'Generation Time',
	//   },
	//   {
	//     id: 'companyName',
	//     display: 'Company Name',
	//   }
	// ]

	const [reportType, setReportType] = useState("Employee Data");
	const [reportName, setReportName] = useState("");
	const [tableData, setTableData] = useState([["", ""]]);

	const updateCell = (cellData, rowIndex, columnIndex) => {
		let newTableData = [...tableData];
		newTableData[rowIndex][columnIndex] = cellData;
		setTableData(newTableData);
	};

	const addRow = () => {
		let newRow = tableData[0].map((item) => {
			return "";
		});

		setTableData([...tableData, newRow]);
	};

	const addColumn = () => {
		let newTableData = tableData.map((row) => [...row, ""]);

		setTableData(newTableData);
	};

	const [columnData, setColumnData] = useState([[" ", " "]]);
	const [sendingForm, setSendingForm] = useState(false);
	const [errorSaving, setErrorSaving] = useState(false);
	const [reportGroup, setReportGroup] = useState(false);

	const updateColumnCell = (cellData, rowIndex, columnIndex) => {
		let newTableData = [...columnData];
		newTableData[rowIndex][columnIndex] = cellData;
		setColumnData(newTableData);
	};

	const addNewColumn = () => {
		let newRow = columnData[0].map((item) => {
			return "";
		});

		setColumnData([...columnData, newRow]);
	};

	const cleanArray = (array) => {
		return array.map((item) => (item == "" ? null : Array.isArray(item) ? cleanArray(item) : item));
	};

	const saveReportTemplate = () => {
		// axios.defaults.withCredentials = true;
		// axios.defaults.crossDomain = true;

		setErrorSaving(false);

		if (sendingForm) {
			return;
		}
		setSendingForm(true);

		const data = {
			reportType,
			name: reportName,
			reportGroup: reportGroup?.value ?? "Employee",
			header: cleanArray(tableData),
			columns: cleanArray(columnData),
		};

		// console.log(data);return;

		if (reportId && reportId != "new") {
			data.id = reportId;
		}

		if (isAdvisor) {
			data.advisor = true;
		}

		fetch(apiURL + "/report/template", {
			// fetch('http://localhost:3000/report/template' , {
			credentials: "include",
			method: "POST",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data),
		})
			/*
      axios.post('https://api.buddy.hr/v1/report/template', ,{
        withCredentials: true,
        crossDomain: true,
        headers: {
            'Content-Type': 'application/json'
        },
      })*/
			.then(function (response) {
				if (response.ok) {
					response.json().then((json) => {
						console.log(json);
						if (json.result == "success") {
							reportId = json.report.id;
						} else {
							setSendingForm(false);
							setErrorSaving(true);
						}
					});
				}
			})
			// .then(NotificationManager.success('Your changes have been saved!', 'Success'))
			.catch(function (error) {
				console.log("not saved", error);
			});
	};

	return (
		<div>
			{/* <NotificationContainer/> */}
			<div className="block">
				<div className="block-content">
					<div className="p-0" style={{marginRight: -15, marginLeft: -15}}>
						<div className="col-sm-5">
							<label htmlFor="material-text">Name</label>
							<div className="form-material">
								<input
									id="report-name"
									type="text"
									className="input-small form-control"
									name="name"
									value={reportName}
									onChange={(e) => {
										setReportName(e.target.value);
									}}
								></input>
							</div>

							<div className="clearfix" />
						</div>

						<div className="col-sm-5">
							<label htmlFor="material-text">Report Type</label>

							<div className="input-report input-group">
								<select
									onChange={changeReportType}
									className="js-select2 form-control"
									id="report-type"
									name="report-type"
									style={{ width: "100%" }}
									tabIndex="-1"
									aria-hidden="true"
								>
									<option selected={reportType == "Employee Data"}>Employee Data</option>
									<option selected={reportType == "Consolidated Payroll Data"}>
										Consolidated Payroll Data
									</option>
									<option selected={reportType == "Payroll Data by Employee"}>
										Payroll Data by Employee
									</option>
									<option selected={reportType == "Payroll Breakdown"}>Payroll Breakdown</option>
								</select>
							</div>

							<div className="clearfix" />
						</div>

						<div className="clearfix" />

						{/* Add option to select which report group this should show inside of */}
						<div className="col-sm-5">
							<label htmlFor="material-text">Report Group</label>
							<BuddySelector
								options={reportGroupOptions}
								value={reportGroup}
								onChange={(value) => setReportGroup(value)}
							/>
						</div>
					</div>


					<div className="clearfix" />

				</div>
			</div>

			{/*<div className="block">
				<div className="clearfix" />
				<div className="block-header">
					<h3 className="block-title">Report Header</h3>
				</div>
				<div className="block-content">
					<div
						className="row"
						style={{ padding: "15px" }}
					>
						<ReportHeaderTable
							tableData={tableData}
							mentionVariables={headerVariables}
							updateCell={updateCell}
							addRow={addRow}
							addColumn={addColumn}
						/>
					</div>
				</div>
			</div>*/}

			<div className="clearfix"/>

			<div className="block">
				<div className="block-header">
					<h3 className="block-title">Report Columns</h3>
				</div>
				<div className="block-content">
					<div
						className="row"
						style={{ padding: "15px" }}
					>
						<ReportHeaderTable
							inverted={true}
							tableData={columnData}
							mentionVariables={columnVariables}
							updateCell={updateColumnCell}
							addRow={addNewColumn}
						/>
					</div>
				</div>
			</div>

			<button
				className="btn btn-success pull-right"
				onClick={saveReportTemplate}
			>
				{!sendingForm ? "Save Report Template" : "Template Saved!"}
			</button>
			{sendingForm && !isAdvisor && (
				<Link
					className="block-content"
					to="/organisation/reports/"
				>
					View your reports here
				</Link>
			)}
			{errorSaving && (
				<span className="block-content span-alert">Error saving (make sure you filled all the cells).</span>
			)}
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		favouritedReports: state.company?.favouritedReports || [],
	};
};

const mapDispatchToProps = (dispatch) => ({
	saveCustomReports: (data) => dispatch(REPORTACTIONS.postCustomReports(data)),
	saveFavouritedReports: (data) => dispatch(REPORTACTIONS.saveFavouritedReports(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportBuilder);
